<!-- eslint-disable vue/multiline-html-element-content-newline -->
<template>
  <div>
    <b-overlay
      :show="loading"
      :variant="'white'"
      :opacity="0.7"
      :blur="'2px'"
      rounded="sm"
    >
      <div
        :class="`alert alert-${alertType}`"
        role="alert"
      >
        <i :class="`bi bi-${processMessagIcon}`" />
        {{ $t(`datasetDetail.mainResource.messages.${processMessage}`) }}
        <router-link
          :to="{
            name: 'TaskDetail',
            params: { id: taskId }
          }"
          class="alert-link"
        >{{ $t('words.here') }}</router-link>.
      </div>
    </b-overlay>
  </div>
</template>

<script>
import datasetAPI from '@/api/modules/dataset.api.js';
export default {
  name: 'ResourceProcessingAlert',

  props: {
    process: {
      type: Object,
      required: true
    },
    resourceId: {
      type: Number,
      required: true
    },
    resource: {
      type: Object,
      default: ()=>({})
    },
    type: {
      type: Number,
      default: 1
    },
    taskId: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      loading: false,
      reloadIntervalIds:[]
    };
  },

  computed: {
   
    alertType() {
      if (this.process.state === 'PENDING') {
        return 'secondary';
      } else {
        return 'danger';
      }
    },
    processMessage() {
      if (this.process.state === 'PENDING') {
        return 'pending';
      } else {
        return 'failure';
      }
    },
    processMessagIcon() {
      if (this.process.state === 'PENDING') {
        return 'hourglass-split';
      } else {
        return 'exclamation-triangle-fill';
      }
    }
  },

  watch: {
    taskId(newValue, oldValue) {
      if (newValue && newValue !== oldValue && this.resourceId) {
        this.checkResourceProcessing(this.resourceId);
      }
    }
  },

  created() {
    if (this.resourceId) {
      this.checkResourceProcessing(this.resourceId);
    }
  },

  methods: {
   
    SET_RELOAD_INTERVAL_ID ( payload){
      this.reloadIntervalIds[payload.name] = payload.interval;
    },

    CLEAR_RELOAD_INTERVAL_ID( name){
      clearInterval(this.reloadIntervalIds[name]);
      this.reloadIntervalIds[name] = null;
    },
    async checkResourceProcessing(id) {
      if (this.resource.isProcessingPending()) {
        this.loading = true;
        //TODO : check only related resource not main
        let resource= await datasetAPI.getDatasetResource(this.$route.params.id,this.resource.id);
        this.$set(this.resource,'_processing',resource._processing);
        if(!resource.isProcessingPending()){
          this.$emit('resource-processed',resource);
        }
        
        this.loading = false;
        this.CLEAR_RELOAD_INTERVAL_ID(`resource_reloading-${id}`);
        this.SET_RELOAD_INTERVAL_ID(
          {
            name: `resource_reloading-${id}`,
            interval: setInterval(async () => {
              await this.checkResourceProcessing(id);
            },
            this.$config.reloadInterval)
          }
        );
      } else {
        this.CLEAR_RELOAD_INTERVAL_ID(`resource_reloading-${id}`);
      }
    },
  }
};
</script>
